<template>
    <LinkHover
        :type="currentComponent"
        :to="$trl(currentRoute)"
        :class="['post', 'block-related']"
        :href="currentHref"
        :target="target"
    >
        <div class="default content">
            <IconArrow/>
            <span class="caption">
                {{ post.caption }}
            </span>
        </div>
        <template v-slot:hover>
            <div class="hover content">
                <IconArrow/>
                <span class="caption">
                    {{ post.caption }}
                </span>
            </div>
        </template>
    </LinkHover>
</template>
<script>
const routes = {
    project: 'Project',
    market: 'Market',
    technique: 'Technique',
    story: 'Story'
}
import LinkHover from '@/components/animation/LinkHover'
import IconArrow from '@/components/IconArrow'
export default {
    components: {
        LinkHover,
        IconArrow
    },
    props: {
        post: {
            type: Object,
            default() {}
        }
    },
    computed: {
        currentComponent() {
            return this.post.type === 'object' || this.post.type === 'link' ? 'router-link' : 'a'
        },
        currentRoute() {
            if(this.post.type === 'object') {
                if(this.post.object.post_type === "custom-page") {
                    return {
                        name: this.post.object.post_name,
                        params: {
                            locale: this.$route.params.locale
                        }
                    }
                } else {
                    return {
                        name: routes[this.post.object.post_type],
                        params: {
                            slug: this.post.object.post_name,
                            locale: this.$route.params.locale
                        }
                    }
                }
            } else if (this.post.type === 'link'){
                return {
                    name: this.post.link
                }
            } else {
                return {}
            }
        },
        currentHref() {
            if(this.post.type === 'object' || this.post.type === 'link') {
                return null
            } else if(this.post.type === 'url'){
                return this.post.url
            } else if(this.post.type === 'download'){
                return this.post.file
            }
            console.log(new Error('post type must be "object", "url" or "download"'))
            return ''
        },
        target() {
            if(this.post.type === 'object' || this.post.type === 'link') {
                return '_self'
            } else {
                return '_blank'
            }

        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.post
    flex: 1
    box-sizing: border-box
    display: flex
    text-decoration: none
    min-height: 80px
    &:first-child:last-child
        border: 1px solid #e5e5e5
    &+.post
        border-top: 1px solid #e0e1e3
.content
    display: flex
    height: 80px
    align-items: center
    width: 100%
.hover
    background-color: #ff2b2a
    .caption
        color: #ffffff

    svg
        /deep/ path
            fill: #ffffff

svg
    margin-left: 60px
    margin-right: 32px


.caption
    font-size: 17px
    color: #636772
    font-weight: 500
    line-height: 1.2
    min-height: 2.4em
    flex: 1
    display: flex
    flex-direction: column
    justify-content: center
    margin-right: 60px
</style>
